import * as actionTypes from 'redux/actions'
import { getPlacementCardKey } from 'utils/getPlacementCardKey'

const initialState = {
  strategies: {
    v: false,
    d: false,
    t: false
  },
  placements: {
    cards: {
      STBMainBanner: {
        id: 'STBMainBanner',
        name: 'TV - Main Banner',
        type: 'stb_main_bannar',
        placement_id: '3'
      },
      STBBanner: {
        id: 'STBBanner',
        name: 'TV - Banner',
        type: 'stb_bannar',
        placement_id: '9'
      },
      STBHalfBanner: {
        id: 'STBHalfBanner',

        name: 'TV - Half Banner',
        type: 'stb_half_bannar',
        placement_id: '12'
      },
      STBSidebarBanner: {
        id: 'STBSidebarBanner',
        name: 'TV - Sidebar Banner',
        type: 'stb_sidebar_bannar',
        placement_id: '14'
      },
      STBSquareBanner: {
        id: 'STBSquareBanner',
        name: 'TV - Square Banner',
        type: 'stb_square_bannar',
        placement_id: '16'
      },
      STBPopup: {
        id: 'STBPopup',
        name: 'TV - Pop up',
        type: 'stb_popup',
        placement_id: '7'
      },
      STBThread: {
        id: 'STBThread',
        name: 'TV - Thread',
        type: 'stb_thread',
        placement_id: '2'
      },
      STBSkippable: {
        id: 'STBSkippable',
        name: 'TV - Skippable Ad',
        type: 'stb_s_ad',
        placement_id: '1'
      },
      STBUnskippable: {
        id: 'STBUnskippable',
        name: 'TV - Unskippable Ad',
        type: 'stb_un_ad',
        placement_id: '6'
      },
      AppBanner: {
        id: 'AppBanner',
        name: 'App - Banner',
        type: 'app_bannar',
        placement_id: '10'
      },
      AppDetailBanner: {
        id: 'AppDetailBanner',
        name: 'App - Detail Banner',
        type: 'app_detail_bannar',
        placement_id: '20'
      },
      AppCarouselAd: {
        id: 'AppCarouselAd',
        name: 'App - Carousel Ad',
        type: 'app_carousel_ad',
        placement_id: '18'
      },
      AppPopup: {
        id: 'AppPopup',
        name: 'App - PopUp',
        type: 'app_popup',
        placement_id: '4'
      },
      AppThread: {
        id: 'AppThread',
        name: 'App - Thread',
        type: 'app_thread',
        placement_id: '3'
      },
      AppSkippable: {
        id: 'AppSkippable',
        name: 'App - Skippable Ad',
        type: 'app_s_ad',
        placement_id: '5'
      },
      AppUnskippable: {
        id: 'AppUnskippable',
        name: 'App - Unskippable Ad',
        type: 'app_un_ad',
        placement_id: '8'
      }
    },
    SelectedCard: {
      type: 'image'
    }
  }
}

const getImageDimensions = src => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.src = src
    image.onload = () => {
      resolve({ width: image.width, height: image.height })
    }
  })
}
// convert "v.d.t" to {v: true, d: true, t: true}
const convertToBoolean = str => {
  let obj = {}
  if (str) {
    str.split('.').forEach(item => {
      obj[item] = true
    })
    return obj
  } else {
    return initialState.strategies
  }
}

const newPlacementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_EDITED_CAMPAIGN:
      const {
        campagin_platform,
        campagin_strategy,
        package_name
      } = action.payload
      if (action.payload?.placements) {
        action.payload.placements.forEach(placement => {
          const {
            placement_name,
            cam_placement_id,
            placement_id,
            cam_placement_title,
            cam_placement_logo,
            cam_placement_link,
            cam_placement_description,
            fileDuration,
            fileResolution_x,
            fileResolution_y,
            fileformat,
            filesize,
            cam_placement_thumbnail
          } = placement
          const placementKey = getPlacementCardKey(placement_name)
          state.placements.cards[placementKey] = {
            ...state.placements.cards[placementKey],
            cam_placement_id,
            placement_id,
            file: {
              importedFile: {
                name: cam_placement_title,
                path: cam_placement_title,
                type: cam_placement_logo.split('.')[
                  cam_placement_logo.split('.')?.length - 1
                ],
                size: filesize
              },
              link: cam_placement_logo,
              preview:
                fileformat === 'mp4'
                  ? cam_placement_thumbnail
                  : cam_placement_logo,
              fileName: cam_placement_logo.split('/')[
                cam_placement_logo.split('/')?.length - 1
              ],
              fileType:
                fileformat ??
                cam_placement_logo.split('.')[
                  cam_placement_logo.split('.')?.length - 1
                ]
            },
            Info: {
              duration: fileDuration,
              dimensions: `${fileResolution_x}x${fileResolution_y}`,
              height: fileResolution_y,
              width: fileResolution_x
            },
            title: cam_placement_title,
            hyperlink: cam_placement_link,
            description: cam_placement_description
          }
          getImageDimensions(cam_placement_logo).then(dimensions => {
            state.placements.cards[
              placementKey
            ].Info.dimensions = `${dimensions.width} x ${dimensions.height}`
            state.placements.cards[placementKey].Info.height = dimensions.height
            state.placements.cards[placementKey].Info.width = dimensions.width
          })
        })
      }

      return {
        ...state,
        strategies: convertToBoolean(campagin_strategy),
        platform: campagin_platform,
        adPackage: {
          packageName: package_name
        },
        campaign: action.payload
      }

    case actionTypes.SET_PLACEMENT_FILE:
      const cards = { ...state.placements.cards }
      if (action.payload.loading) {
        cards[state.placements.SelectedCard.name].loading = true
        cards[state.placements.SelectedCard.name].failed = false
        state.placements.SelectedCard.loading = true
      } else if (action.payload.failed) {
        cards[state.placements.SelectedCard.name].failed = true
        cards[state.placements.SelectedCard.name].loading = false
        state.placements.SelectedCard.loading = false
      } else if (typeof action.payload === 'string') {
        state.placements.cards[action.payload].file = null
        state.placements.cards[action.payload].Info = null
        state.placements.SelectedCard.loading = false
      } else {
        cards[state.placements.SelectedCard.name].file = action.payload.file
        cards[state.placements.SelectedCard.name].Info = action.payload.Info
        cards[state.placements.SelectedCard.name].loading = false
        cards[state.placements.SelectedCard.name].failed = false
        cards[state.placements.SelectedCard.name].isNewPlacement = true
        cards[state.placements.SelectedCard.name].isNewImage = true
        state.placements.SelectedCard.loading = false
      }
      return {
        ...state,
        placements: {
          ...state.placements,
          cards: {
            ...state.placements.cards
          }
        }
      }

    case actionTypes.SELECT_PLACEMENT_CARD: {
      if (!state.placements.cards[action.payload.name]) {
        state.placements.cards = {
          ...state.placements.cards,
          [action.payload.name]: {}
        }
      }
      return {
        ...state,
        placements: {
          ...state.placements,
          SelectedCard: action.payload
        }
      }
    }

    case actionTypes.PLACEMENT_TITLE:
      state.placements.cards[
        state.placements.SelectedCard.name
      ].isNewPlacement = true
      state.placements.cards[state.placements.SelectedCard.name]['title'] =
        action.payload
      return {
        ...state
      }
    case actionTypes.PLACEMENT_HYPERLINK: {
      state.placements.cards[
        state.placements.SelectedCard.name
      ].isNewPlacement = true
      state.placements.cards[state.placements.SelectedCard.name]['hyperlink'] =
        action.payload
      return {
        ...state
      }
    }

    case actionTypes.PLACEMENT_DESCRIPTION: {
      state.placements.cards[
        state.placements.SelectedCard.name
      ].isNewPlacement = true
      state.placements.cards[state.placements.SelectedCard.name][
        'description'
      ] = action.payload
      return {
        ...state
      }
    }
    case actionTypes.RESET_EDIT_PLACEMENTS: {
      Object.values(state.placements.cards).forEach(card => {
        card.file && URL.revokeObjectURL(card.file.link)
      })
      return {
        ...state,
        placements: {
          cards: {
            STBMainBanner: {
              id: 'STBMainBanner',
              name: 'TV - Main Banner',
              type: 'stb_main_bannar',
              placement_id: '3'
            },
            STBBanner: {
              id: 'STBBanner',
              name: 'TV - Banner',
              type: 'stb_bannar',
              placement_id: '9'
            },
            STBHalfBanner: {
              id: 'STBHalfBanner',
              name: 'TV - Half Banner',
              type: 'stb_half_bannar',
              placement_id: '12'
            },
            STBSidebarBanner: {
              id: 'STBSidebarBanner',
              name: 'TV - Sidebar Banner',
              type: 'stb_sidebar_bannar',
              placement_id: '14'
            },
            STBSquareBanner: {
              id: 'STBSquareBanner',
              name: 'TV - Square Banner',
              type: 'stb_square_bannar',
              placement_id: '16'
            },
            STBPopup: {
              id: 'STBPopup',
              name: 'TV - Pop up',
              type: 'stb_popup',
              placement_id: '7'
            },
            STBThread: {
              id: 'STBThread',
              name: 'TV - Thread',
              type: 'stb_thread',
              placement_id: '2'
            },
            STBSkippable: {
              id: 'STBSkippable',
              name: 'TV - Skippable Ad',
              type: 'stb_s_ad',
              placement_id: '1'
            },
            STBUnskippable: {
              id: 'STBUnskippable',
              name: 'TV - Unskippable Ad',
              type: 'stb_un_ad',
              placement_id: '6'
            },
            AppBanner: {
              id: 'AppBanner',
              name: 'App - Banner',
              type: 'app_bannar',
              placement_id: '10'
            },
            AppDetailBanner: {
              id: 'AppDetailBanner',
              name: 'App - Detail Banner',
              type: 'app_detail_bannar',
              placement_id: '20'
            },
            AppCarouselAd: {
              id: 'AppCarouselAd',
              name: 'App - Carousel Ad',
              type: 'app_carousel_ad',
              placement_id: '18'
            },
            AppPopup: {
              id: 'AppPopup',
              name: 'App - PopUp',
              type: 'app_popup',
              placement_id: '4'
            },
            AppThread: {
              id: 'AppThread',
              name: 'App - Thread',
              type: 'app_thread',
              placement_id: '3'
            },
            AppSkippable: {
              id: 'AppSkippable',
              name: 'App - Skippable Ad',
              type: 'app_s_ad',
              placement_id: '5'
            },
            AppUnskippable: {
              id: 'AppUnskippable',
              name: 'App - Unskippable Ad',
              type: 'app_un_ad',
              placement_id: '8'
            }
          },
          SelectedCard: {
            type: 'image'
          }
        }
      }
    }

    default: {
      return state
    }
  }
}

export default newPlacementsReducer
